import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiHtml5,
  DiCss3,
} from "react-icons/di";
import {
  SiTypescript,
  SiNextdotjs,
  SiTailwindcss,
  SiExpress,
  SiPostgresql,
  SiRedis,
  SiGraphql,
  SiDocker,
  SiFigma,
  SiPostman,
  SiVisualstudiocode,
  SiGithub,
  SiVuedotjs,
  SiAngular,
  SiFirebase,
  SiMysql,
  SiNestjs,
  SiDjango,
  SiFlask,
} from "react-icons/si";
import { FaServer } from "react-icons/fa";

const getIconByName = (iconName) => {
  const iconMap = {
    javascript: DiJavascript1,
    react: DiReact,
    nextjs: SiNextdotjs,
    typescript: SiTypescript,
    html5: DiHtml5,
    css3: DiCss3,
    tailwindcss: SiTailwindcss,
    nodejs: DiNodejs,
    express: SiExpress,
    mongodb: DiMongodb,
    postgresql: SiPostgresql,
    mysql: SiMysql,
    redis: SiRedis,
    graphql: SiGraphql,
    api: FaServer,
    nestjs: SiNestjs,
    python: DiPython,
    django: SiDjango,
    flask: SiFlask,
    git: DiGit,
    github: SiGithub,
    vscode: SiVisualstudiocode,
    docker: SiDocker,
    figma: SiFigma,
    postman: SiPostman,
    vue: SiVuedotjs,
    angular: SiAngular,
    firebase: SiFirebase,
  };

  return iconMap[iconName?.toLowerCase()] || DiJavascript1;
};

function Techstack({ skills }) {
  if (!skills || skills.length === 0) {
    return (
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <p className="text-white">Add your tech skills in the Admin Panel.</p>
      </Row>
    );
  }

  return (
    <Row
      style={{ justifyContent: "center", paddingBottom: "50px", gap: "20px" }}
    >
      {skills.map((skill) => {
        const IconComponent = getIconByName(skill.icon);
        return (
          <Col
            xs={5}
            sm={4}
            md={2}
            lg={2}
            className="tech-icons text-center"
            key={skill._id}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              margin: "10px",
              borderRadius: "15px",
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(199, 112, 240, 0.2)",
              transition: "all 0.3s ease",
              minHeight: "140px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.borderColor = "#c770f0";
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(199, 112, 240, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.borderColor = "rgba(199, 112, 240, 0.2)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <IconComponent style={{ fontSize: "3.5rem", color: "#c770f0" }} />
            <div
              className="tech-icons-text"
              style={{
                marginTop: "12px",
                textAlign: "center",
                fontSize: "0.95rem",
                fontWeight: "600",
                color: "#fff",
              }}
            >
              {skill.name}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default Techstack;
